export class DocumentIndentificationModel {
    public externalId: string;
    public referenceNo: string;
    public documentType: string;
    public clientEid: string;
}